module.exports = __webpack_public_path__ + "img/20220723161885658565.f391ef3a.jpg";